import {
  aiSelectData,
  AiSelectDataItem,
} from '@/pages/ISWAN_CHAT/components/AISelectMenu/index.data';
import FillImage from '@/pages/ISWAN_CHAT/components/FillImage/FillImage';
import { AIType } from '@/pages/ISWAN_CHAT/interface';
import { useModel } from '@umijs/max';
import { Tag } from 'antd';
import s from './index.less';

export interface AISelectMenuProps {
  onClick?: (aiType: AIType) => void;
}

const AISelectMenu = (props: AISelectMenuProps) => {
  const { initialState } = useModel('@@initialState');
  const [aiType, setAiType] = useModel('ISWAN_CHAT.aiType');

  const handleClick = (type: AIType, item: AiSelectDataItem) => {
    const role = !!initialState?.envInfo?.iyb ? 'iyb' : 'compony';

    if (role === 'iyb' && item.onlyCompany) {
      window.open('https://iswan.cc/edatlink-publicize/', '_blank');
      return;
    }

    if (props?.onClick) {
      props.onClick(type);
      return;
    }

    setAiType(type);
  };

  return (
    <>
      <div className={s.main}>
        {aiSelectData.map((item) => {
          return (
            <>
              <div
                className={`${s.item} ${aiType === item.value ? s.itemActive : ''}`}
                onClick={() => handleClick(item.value, item)}
              >
                <div className={s.hoverBg} />
                <div className={s.icon}>
                  <FillImage src={aiType === item.value ? item.icon_active : item.icon} />
                </div>
                <div className={`${s.label}`}>{item.label}</div>
                {item.onlyCompany && (
                  <div className={s.tag}>
                    <Tag color={'processing'}>企业版</Tag>
                  </div>
                )}
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default AISelectMenu;
